import { IconStarFilled } from '@tabler/icons-react'
import classNames from 'classnames'
import numberToRating from '../lib/number-to-rating'
import ratingToNumber from '../lib/rating-to-number'
import Rating from '../model/rating'
import styles from './rating-input.module.scss'

interface RatingInputProps {
  value: Rating | null
  onValueChange?: (value: Rating) => void
}

const MAX_RATING = 5

export default function RatingInput({ value, onValueChange }: RatingInputProps) {
  const numericValue = ratingToNumber(value)

  const onNumericValueChange = (newNumericValue: number) => {
    const newValue = numberToRating(newNumericValue)
    onValueChange?.(newValue!)
  }

  return (
    <div className={styles.root}>
      {Array(MAX_RATING)
        .fill(null)
        .map((_, index) => (
          <button
            className={classNames(styles.star, index < numericValue && styles.starEnabled)}
            key={index}
            onClick={() => onNumericValueChange(index + 1)}
          >
            <IconStarFilled />
          </button>
        ))}
    </div>
  )
}
